import { useEffect } from 'react';
import { Outlet, Link as RouterLink, useLocation } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import Footer from '../Footer';
import useAuth from '../../hooks/useAuth';
import { getActionPlan } from '../../slices/actionPlan';
import { useDispatch } from '../../store';
import CookieConsent from 'react-cookie-consent';
import Navbar from './Navbar';

const LayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const LayoutWrapper = experimentalStyled('div')(() => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  flexDirection: 'column',
}));

const LayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch',
  transition: 'padding 0.3s ease-in-out'
});

const Layout = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (auth.isInitialized) {
      if (auth.isAuthenticated) {
        dispatch(getActionPlan(auth.user.id));
      }
    }
  }, [auth.isInitialized]);

  // Check if current path is /professores or /profissoes-primeira-infancia (or their subpages)
  const shouldHidePartners = location.pathname.startsWith('/professores')
                             || location.pathname.startsWith('/profissoes-primeira-infancia');

  return (
    <LayoutRoot>
      <LayoutWrapper>
        <LayoutContent
          className="dashboardLayoutContent"
        >
          <Navbar />
          <Outlet />
          <CookieConsent
            style={{ zIndex: 9999, background: 'linear-gradient(257.68deg, rgba(192, 35, 239, 1) 0%, rgba(62, 0, 131, 1) 100.15%)' }}
            buttonText="Fechar"
            buttonStyle={{
              background: 'rgba(0,0,0,0.5)',
              border: '1px solid #fff',
              color: '#fff',
              fontWeight: 600,
              fontSize: '0.875rem',
              lineHeight: 1.75,
              padding: '6px 16px',
              borderRadius: 16,
              textTransform: 'uppercase',
            }}
          >
            ATENÇÃO! Este site utiliza cookies. Ao navegar no site estará a consentir a sua utilização.&nbsp;
            <RouterLink
              style={{ color: '#fff' }}
              to="/cookies"
            >
              Saiba mais
            </RouterLink>
            &nbsp;
            sobre o uso de cookies.
          </CookieConsent>
          <Footer hidePartners={shouldHidePartners} />
        </LayoutContent>
      </LayoutWrapper>
    </LayoutRoot>
  );
};

export default Layout;
